import React from 'react';

const ProductConversionLinks: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Proudct Conversion Link</h1>
          <p className="text-gray-600 mt-2">
              Product Conversion Link is to change
          </p>
        </div>



        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/productconversationlink/productconversationlink.png"
              alt="Users Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Custom Prouduct Conversion Link</h2>
          <p className="text-gray-600 mb-4">
            Product conversation link means
          </p>
          <p className="text-gray-600 mb-4">
            To add a custom Product Conversion Link:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Prouduct Conversion Link</li>
            <li>Click the New Conversion button in the top right corner of the page.</li>
            <li>Fill the needed information.</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/productconversationlink/productconversationlink-new.png"
              alt="Add Custom DeliveryMethods Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default ProductConversionLinks;
